<dx-select-box
  #languageSelect
  [(value)]="value"
  valueExpr="id"
  displayExpr="name"
  [placeholder]="'select' | translate"
  [dataSource]="languages"
  [searchEnabled]="false"
  [attr.aria-label]="'switch_language' | translate"
  (valueChange)="modelChanged()"
>
  <div *dxTemplate="let item of 'item'">
    <span [attr.lang]="item.lang">{{ item.name }}</span>
  </div>
</dx-select-box>
